// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8150580","732":"4e4f35ab","977":"b90f7718"}[chunkId] + ".chunk.js";
};